//-
//- The Bootstrap Relay Service fixes the issue of angular not receiving bootstrap events.
//- For more info on how it works, see my post on stackoverflow:
//- https://stackoverflow.com/questions/34495307/angular2-with-bootstrap-events-does-not-trigger-observable-changes/46458318?noredirect=1#comment80175785_46458318
//-

import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

enum RelayState {
  Uninitialized,
  Initializing,
  Initialized
}

@Injectable()
export class BootstrapRelayService {
  relayEventStack:Set<string> = new Set();
  relayState:RelayState = RelayState.Uninitialized;

  constructor( private http:Http ) { 
  }

  //This works and is the best solution.  Most concise.  
  //And don't need to worry about unsubscribing an observable.
  http_loadfile():Promise<string> {      
      return this.http.get('/assets/bootstrapEventRelay.js')
        .map(res => res.text() )
        .toPromise();
  }

  //begin the init process to inject 'relayEvent' into the DOM's javascript.
  private initialize(){
    this.http_loadfile().then((text) => {
      var script = document.createElement('script');
      script.innerHTML = text
      document.body.appendChild(script);
      this.relayState = RelayState.Initialized;
      this.registerEventsOnStack();
    });
  }

  //register each event on the stack, to monitor for duplicates
  private registerEventsOnStack(){
    this.relayEventStack.forEach(event => {
      this.constructRelayForEvent(event);
    });
  }

  //dynamically execute the event relays
  private constructRelayForEvent(event){
    var script = document.createElement('script');
    script.innerHTML = "eventRelay('"+event+"');"
    document.body.appendChild(script);
  }

  
  //This is the one public method for components to call
  public registerEvent(event:string){
    // console.log('relayEvent request for: ', event);
    //guard that event hasn't already been added
    let eventAlreadyAdded = this.relayEventStack.has(event);
    if (eventAlreadyAdded) {
      // console.log('**attempted to reregister event', event);
      return;
    }
    this.relayEventStack.add(event);
    //Initialized = inject relayEvent
    //Uninitialized = begin init
    if (this.relayState == RelayState.Initialized){
      //inject the new/unique relayEvent.
      this.constructRelayForEvent(event);
    } else if (this.relayState == RelayState.Uninitialized){
        //begin the init process
        this.initialize();
        this.relayState = RelayState.Initializing;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/bootstrap-relay.service.ts